import { Badge } from '@/components/ui/badge';
import { useCallsList } from '@/hooks/useCallsList';
import { Button } from '@/components/ui/button';

function callName(call: any) {
  const contact = call.contact;
  if (!contact) return call.to_e164 || call.from_e164 || 'Sem contato';
  const full = `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
  return full || contact.primary_phone || 'Sem contato';
}

function formatCallDate(value?: string | null) {
  if (!value) return 'Data indisponivel';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Data indisponivel';
  return date.toLocaleString('pt-BR');
}

export default function MobileCalls() {
  const { calls, loading, error, page, setPage, totalCount, pageSize } = useCallsList({});

  const hasPrev = page > 1;
  const hasNext = page * pageSize < totalCount;

  return (
    <div className="space-y-2 p-3">
      {loading ? <p className="text-sm text-muted-foreground">Carregando chamadas...</p> : null}
      {error ? <p className="text-sm text-destructive">Erro ao carregar chamadas.</p> : null}

      {calls.map((call) => (
        <div key={call.id} className="rounded-lg border bg-card p-3">
          <p className="text-sm font-semibold">{callName(call)}</p>
          <div className="mt-2 flex items-center gap-2 text-xs">
            <Badge variant="outline">{call.direction || 'sem direcao'}</Badge>
            <Badge variant="secondary">{call.displayStatus || call.status || 'sem status'}</Badge>
            <span className="text-muted-foreground">{formatCallDate(call.created_at)}</span>
          </div>
        </div>
      ))}

      {!loading && calls.length === 0 ? (
        <p className="text-sm text-muted-foreground">Nenhuma chamada encontrada.</p>
      ) : null}

      <div className="flex items-center justify-between pt-2">
        <Button variant="outline" size="sm" disabled={!hasPrev} onClick={() => setPage((p) => p - 1)}>
          Anterior
        </Button>
        <span className="text-xs text-muted-foreground">Pagina {page}</span>
        <Button variant="outline" size="sm" disabled={!hasNext} onClick={() => setPage((p) => p + 1)}>
          Proxima
        </Button>
      </div>
    </div>
  );
}
